// Mock data for Raz Tattoo Studio

export const translations = {
    en: {
        nav: {
            home: 'Home',
            about: 'About',
            gallery: 'Gallery',
            contact: 'Contact',
        },
        hero: {
            title: 'Raz tattoo',
            subtitle: 'Every Tattoo is a Story, Every Line is Art.',
            description:
                'Premium tattoo artistry, professional piercings, hair simulation, and custom designs in a clean, welcoming environment.',
            ctaPrimary: 'consult or book',
            ctaSecondary: 'View Gallery',
        },
        about: {
            title: 'About Raz',
            description:
                'Raz has been a tattoo artist since 2018, specializing in fine line and delicate tattoos, realistic styles, and cover-ups. His style is based on precision, professionalism, and patience, with a personalized approach for each valued client and their story. All his works are authentic, without filters or edits—just real pictures in natural light.',
            experience: '8+ Years Experience',
            clients: 'Thousands of Happy Clients',
            designs: 'Custom Designs',
            trust: 'We operate under the supervision of the Ministry of Health, adhering to the highest standards and using only the highest quality products.',
        },
        gallery: {
            title: 'Portfolio',
            subtitle: 'Explore my work',
            tabs: {
                piercings: 'Piercings',
                recoveries: 'Tattoos',
                sketches: 'Available Sketches',
                covers: 'Covers',
                hair: 'Hair Simulations',
            },
        },
        contact: {
            title: 'Get In Touch',
            subtitle: 'Ready to start your tattoo journey?',
            whatsapp: 'Chat on WhatsApp',
            address: 'Kikar Noiman, Beit Shemesh',
            hours: 'Sun-Thu: 10:00-19:00, Fri: 9:00-14:00, Motzei Shabbat: By Appointment Only',
        },
        footer: {
            rights: 'All rights reserved',
            followUs: 'Follow Us',
        },
    },
    he: {
        nav: {
            home: 'בית',
            about: 'אודות',
            gallery: 'גלריה',
            contact: 'צור קשר',
        },
        hero: {
            title: 'Raz tattoo',
            subtitle: 'כל קעקוע הוא סיפור, כל קו הוא אמנות.',
            description:
                'אמנות קעקועים מובחרת, פירסינג מקצועי ועיצובים מותאמים אישית, הדמיית זקיקי שיער בשיטת מיקרו-פיגמנטציה. הכל נעשה בסביבה סטרילית, נקייה ומזמינה.',
            ctaPrimary: 'ליעוץ וקביעת תורים',
            ctaSecondary: 'צפה בגלריה',
        },
        about: {
            title: 'אודות רז',
            description:
                'רז הוא מקעקע משנת 2018, ומתמחה בקווים דקים ועדינים בקעקועים ריאליסטים וקאברים. הסגנון שלו מתבסס על דיוק, מקצועיות וסבלנות עם התאמה אישית לכל לקוח יקר ולכל סיפור. כל העבודות שלו אותנטיות ללא פילטרים וללא עריכות אלא רק תמונות אמיתיות על העור.',
            experience: '8+ שנות ניסיון',
            clients: 'אלפי לקוחות מרוצים',
            designs: 'עיצובים מותאמים אישית',
            trust: 'אצלנו הכל בפיקוח משרד הבריאות  אנו עובדים  בקפידה ובהתאם לסטנדרטים המחמירים ביותר ועם המוצרים הכי איכותיים',
        },
        gallery: {
            title: 'תיק עבודות',
            subtitle: 'חקור את העבודות שלי',
            tabs: {
                piercings: 'פירסינג',
                recoveries: 'קעקועים',
                sketches: 'סקיצות זמינות',
                covers: 'קאברים',
                hair: 'הדמיות שיער',
            },
        },
        contact: {
            title: 'צור קשר',
            subtitle: 'מוכן להתחיל את מסע הקעקוע שלך?',
            whatsapp: 'שוחח בוואטסאפ',
            address: 'מרכז מסחרי כיכר נוימן, בית שמש',
            hours: "א'-ה': 10:00-19:00, ו': 9:00-14:00, מוצאי שבת: בתאום מראש בלבד",
        },
        footer: {
            rights: 'כל הזכויות שמורות',
            followUs: 'עקוב אחרינו',
        },
    },
};

export const socialLinks = {
    instagram: 'https://www.instagram.com/raz_tattoo_/reels/',
    facebook: 'https://www.facebook.com/p/Raz-tattoo-100075545514105/_',
    whatsapp: 'https://wa.link/39k461',
};

export const studioInfo = {
    logo: 'logo.png',
    name: 'Raz Tattoo Studio',
    nameHe: 'רז קעקועים',
    phone: '058-7810005',
    phoneLandline: '058-7810005',
    email: 'raztattoo@gmail.com',
    address: 'Kikar Noiman, Beit Shemesh',
    addressHe: 'מרכז מסחרי כיכר נוימן, בית שמש',
    postcode: '5652118',
    established: '1989',
};
